/** localStorage for per-viewer conveniences only (consent seen, dev user name). It can throw or be empty. */
export function readLocal(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeLocal(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* private mode / blocked storage: the page works without it */
  }
}
